export enum SmsTemplateType {
    Verification = 'verification',
    Login = 'login',
    Invitation = 'invitation',
    Mfachallenge = 'mfachallenge',
}